import { createFileRoute } from '@tanstack/react-router'

import { WorkflowLibrary } from '@/pages/Workflows/WorkflowLibrary/WorkflowLibrary'
import { librarySearchSchema } from '@/pages/Workflows/WorkflowLibrary/librarySearchSchema'

export const Route = createFileRoute('/_app/library/')({
  component: WorkflowLibrary,
  validateSearch: librarySearchSchema,
})
